import { Dispatch } from 'redux';

import { tipsConstants } from '../../constants';
import { tipsService } from '../../services';
import { alertActions } from '..';
import { generalErrorHandler } from '../utils';

export default function fetchStockExpertTips(
  stockCode: string,
  expertId?: number
) {
  return (dispatch: Dispatch): Promise<void> => {
    dispatch(request());
    dispatch(alertActions.clear());

    return tipsService.getTips(stockCode, expertId).then(
      data => {
        dispatch(success(data));
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };
}

function request() {
  return { type: tipsConstants.FETCH_STOCK_EXPERT_TIPS_REQUEST };
}

function success(data) {
  return {
    type: tipsConstants.FETCH_STOCK_EXPERT_TIPS_SUCCESS,
    tips: data,
  };
}

function failure(error) {
  return {
    type: tipsConstants.FETCH_STOCK_EXPERT_TIPS_FAILURE,
    error,
  };
}
